import script from "./UpgradeGalaxy.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeGalaxy.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeGalaxy.vue?vue&type=style&index=0&id=2e2833a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e2833a8"]])

export default __exports__